import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { HELP_CENTER_ROUTE_PATHS } from './config';

export const KNOWN_ISSUES_ROUTES: TApplicationRoute[] = [
  {
    id: 'help-center-known-issues',
    path: HELP_CENTER_ROUTE_PATHS.knownIssues,
    component: lazy(() => import('./pages/known-issues-page')),
    layout: 'default',
    permissions: { scopes: ['help-center'] },
    menu: {
      title: 'pages.helpCenter.knownIssues.title',
    },
  },
];
